import { useGetCurrentEmployeesQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import CurrentEmployees from "./CurrentEmployees";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getAppType, hasQueryParam } from "utils/helper";
import PrefilledHealthCensus from "./PrefilledHealthCensus";

interface ICurrentEmployeesModelProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
}

const CurrentEmployeesModel = (
  props: ICurrentEmployeesModelProps
): JSX.Element => {
  const appType = getAppType();
  const { data, error, loading, refetch } = useGetCurrentEmployeesQuery({
    variables: { uuid: getProspectUuid(), appType },
    fetchPolicy: "no-cache",
  });

  const v2_dedupe_census_flow = hasQueryParam("usecensustab");
  const hi_flow_with_core_app = hasQueryParam("usecoreapp");

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorPage />;
  }
  return v2_dedupe_census_flow || hi_flow_with_core_app ? (
    <PrefilledHealthCensus
      data={data?.prospect}
      refetchData={refetch}
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
    />
  ) : (
    <CurrentEmployees
      data={data?.prospect}
      refetchData={refetch}
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
    />
  );
};

export default CurrentEmployeesModel;
